import { ApiResponse } from '../types/api.types';
import { apiService } from './api.service';
import { components } from '../types/generated';

// Types from generated API
export type ChangeVehicleClientRequest =
  components['schemas']['ChangeVehicleClientRequest'];

export class CarService {
  private publicOrdersEndpoint = '/public/orders';

  /**
   * Dodaje nowy pojazd do zamówienia (zmiana pojazdu)
   * Endpoint: POST /public/orders/{uuid}/vehicles
   */
  async changeVehicle(
    orderUuid: string,
    data: ChangeVehicleClientRequest,
  ): Promise<ApiResponse<void>> {
    return apiService.post<void, ChangeVehicleClientRequest>(
      `${this.publicOrdersEndpoint}/${orderUuid}/vehicles`,
      data,
    );
  }

  /**
   * @deprecated Use changeVehicle() instead
   */
  async changeCarUrl(
    orderId: string,
    data: { url: string },
  ): Promise<ApiResponse<void>> {
    return this.changeVehicle(orderId, {
      vehicleAdvertisementLink: data.url,
    });
  }
}

export const carService = new CarService();
